<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
    </div>

    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50]
        }"
        sort-by="name"
        @update:options="updateTable"
        class="elevation-1 fixed-header">
        <template v-slot:item._id="{ item }">
          <a href="#" @click.prevent="openDetail(item._id)">
            {{ item._id }}
          </a>
        </template>
        <template v-slot:item.createdAt = "{ item }">
          {{ item.createdAt | toDate }}
        </template>
        <template v-slot:item.status = "{ item }">
          {{ statuses.find(status => status.value === item.status).text }}
        </template>
        <template v-slot:item.updatedAt="{ item }">
          {{ ago(item.updatedAt) }}
        </template>
      </v-data-table>
    </v-flex>

    <IssuesDetail ref="issuesDetail" :issue="issue" />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import IssuesDetail from '@/components/sidePanels/IssuesDetail'
import moment from 'moment'

export default {
  name: 'Issues',
  components: {
    IssuesDetail
  },
  data () {
    return {
      overlay: false,
      section: this.$i18n.t('issues.section'),
      table: {
        title: this.$i18n.t('issues.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('issues.headers.date'), value: 'createdAt', sortable: false },
          { text: this.$i18n.t('issues.headers.folio'), value: '_id', sortable: false },
          { text: this.$i18n.t('issues.headers.type'), value: 'type', sortable: false },
          { text: this.$i18n.t('issues.headers.restaurant'), value: 'restaurant.name', sortable: false },
          { text: this.$i18n.t('issues.headers.status'), value: 'status', sortable: false },
          { text: this.$i18n.t('issues.headers.updated'), value: 'updatedAt', sortable: false }
        ],
        data: [],
        total: 1,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 50,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      },
      issue: '',
      statuses: [
        { value: '', text: 'Todas' },
        { value: 'open', text: 'Nueva orden' },
        { value: 'in-progress', text: 'Confirmada' },
        { value: 'closed', text: 'Cancelada' },
        { value: 'reopen', text: 'Facturada' }
      ],
      statusSelected: { value: '', text: 'Todas' }
    }
  },
  computed: {
  },
  watch: {
    // ... Watch out! Be Careful
  },
  mounted: async function () {
  },
  methods: {
    async updateTable (data) {
      this.table.options = data
      const params = {}
      try {
        await this.load(params)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    openDetail (issue) {
      this.issue = issue
      this.$refs.issuesDetail.open()
    },
    async load (params) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        sort: `${this.table.options.sortDesc[0] ? '-' : ''}${this.table.options.sortBy[0]}`,
        status: this.statusSelected.value
      }
      this.table.loading = true
      try {
        const response = await this.$api.get(`/v1/issue`, params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    ago (time) {
      return moment(time).fromNow()
    }
  }
}
</script>
